(() => {
  const pageType = document.currentScript?.dataset.pageType;
  const drawerSelector = '.drawer-delivery-promise__title,#menu-drawer .menu-drawer__menu-item';
  const selector = pageType === 'index'
    ? drawerSelector
    : `h1,h2,h3,h4,h5,h6,${drawerSelector}`;
  const saved = new Map();
  let frame;
  function scale() {
    for (const [el, original] of saved) {
      if (!el.isConnected) { saved.delete(el); continue; }
      if (original.value) el.style.setProperty('font-size', original.value, original.priority);
      else el.style.removeProperty('font-size');
    }
    saved.clear();
    const changes = [];
    const exception = document.querySelector('.donation-chapter h2 > span');
    if (exception) changes.push([exception, getComputedStyle(exception).fontSize]);
    document.querySelectorAll(selector).forEach(el => {
      if (el.closest('svg') || el.closest('.zadeyra-circle-footer') || el.querySelector('.header__heading-logo-wrapper')) return;
      // The product reviews heading keeps the px size set in the Reviews block, like the homepage reviews heading.
      if (el.closest('#zadeyra-product-reviews .zadeyra-reviews__header')) return;
      // The UGC Reels heading keeps the px size set by the section sliders.
      if (el.closest('.ugc-homepage-caption')) return;
      const css = getComputedStyle(el);
      if (!css.fontFamily.toLowerCase().includes('montserrat')) return;
      if (el.parentElement.closest(selector)) return;
      changes.push([el, `${parseFloat(css.fontSize) * 0.8}px`]);
    });
    for (const [el, size] of changes) {
      saved.set(el, {value: el.style.getPropertyValue('font-size'), priority: el.style.getPropertyPriority('font-size')});
      el.style.setProperty('font-size', size, 'important');
    }
  }
  function schedule() { cancelAnimationFrame(frame); frame = requestAnimationFrame(scale); }
  schedule();
  window.addEventListener('load', schedule, {once:true});
  window.addEventListener('resize', schedule, {passive:true});
  document.fonts?.ready.then(schedule);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(records => {
    if (records.some(record => record.addedNodes.length || record.removedNodes.length)) schedule();
  }).observe(document.body, {childList:true, subtree:true});
})();
